module.exports = __webpack_public_path__ + "img/sw_hito.068feb51.svg";